export default function addMonthsToDate(date: string | number | Date | null, months: number): Date {
  const result = new Date(date ?? 0);
  result.setMonth(result.getMonth() + months);
  return result;
}
